import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TreatmentDetailsModalData} from '../../../types/TreatmentDetailsModalData';
import {BookingServiceDetail} from '../../../types/BookingServiceDetail';

@Component({
  selector: 'app-treatment-details-modal',
  templateUrl: './treatment-details-modal.component.html',
  styleUrls: ['./treatment-details-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreatmentDetailsModalComponent implements OnInit {
  public customCssClass: string = '';

  constructor(
    public dialogRef: MatDialogRef<TreatmentDetailsModalComponent>,
    private _change: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public content: TreatmentDetailsModalData,
  ) {}

  public ngOnInit() {
    this.updateCustomCssClass();
    this._change.markForCheck();
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public book(): void {
    const service: BookingServiceDetail = {
      id: this.content.id,
      name: this.content.name,
      activityLength: this.content.activityLength,
      price: this.content.price,
      priceInfo: this.content.priceInfo,
      note: this.content.note,
      seoInformation: this.content.seoInformation,
      links: this.content.links,
      isFromPrice: this.content.isFromPrice,
      priceDescription: this.content.priceDescription,
      twoFactorAuthenticationRequired: this.content.twoFactorAuthenticationRequired,
    };
    this.content.bookCallback(service);
    this._change.markForCheck();
    this.dialogRef.close();
  }

  private updateCustomCssClass(): void {
    this.customCssClass = this.content.showBookingButton ? '' : 'no-action';
  }
}
